var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1.25,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#EBEBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.589h7.982c.04 0 .063-.047.038-.08l-1.407-1.757M12.084 10.606H4.118a.048.048 0 00-.034.083l1.754 1.754",
    stroke: "#604DBC",
    strokeLinecap: "square"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxNyAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iMS4yNSIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiByeD0iOCIgZmlsbD0iI0VCRUJGRiIvPgo8cGF0aCBkPSJNNCA3LjU4ODU2SDExLjk4MkMxMi4wMjI2IDcuNTg4NTYgMTIuMDQ1MSA3LjU0MTYzIDEyLjAxOTggNy41MDk5NUwxMC42MTMxIDUuNzUxNTkiIHN0cm9rZT0iIzYwNERCQyIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBkPSJNMTIuMDg0IDEwLjYwNjRMNC4xMTgxMiAxMC42MDY0QzQuMDc1MDIgMTAuNjA2NCA0LjA1MzQzIDEwLjY1ODUgNC4wODM5MSAxMC42ODlMNS44MzgyOSAxMi40NDM0IiBzdHJva2U9IiM2MDREQkMiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPC9zdmc+Cg==";
export { SvgSwitchRound as ReactComponent };